import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplicateInformationDetailsComponent } from './replicate-information-details.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PosListModule } from 'src/app/shared/pos-list/pos-list.module';
import { FormsModule } from '@angular/forms';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';



@NgModule({
  declarations: [
    ReplicateInformationDetailsComponent
  ],
  imports: [
    CommonModule,
    AccordionModule,
    PosListModule,
    FormsModule,
    PosTableModule
  ],
  exports: [ReplicateInformationDetailsComponent]
})
export class ReplicateInformationDetailsModule { }
